<script setup lang="ts">
// types
import type { SectionDisciplineNeedsProps } from '@ts-sections/section-discipline-needs/interfaces'
// hooks
import { useSectionDisciplineNeeds } from '@hooks/sections/section-discipline-needs.hook'
// assets
import decorationDesktop from '@images/sections/discipline-needs/decoration-desktop.svg'
import decorationMobile from '@images/sections/discipline-needs/decoration-mobile.svg'
import photo from '@images/sections/discipline-needs/photo.jpg'
import photoWebp from '@images/sections/discipline-needs/photo.webp'
// components
import BlockLinkCard from '@Blocks/BlockLinkCard.vue'
import { SectionLayout } from '@UI/Layouts/SectionLayout'

defineOptions({
  name: 'SectionDisciplineNeeds',
})

const props = defineProps<{
  section: SectionDisciplineNeedsProps
}>()

const {
  refTitle,
  refDescription,
  refBackgroundColor,
} = useSectionDisciplineNeeds({
  section: () => props.section,
})
</script>

<template>
  <SectionLayout
    class="section-discipline-needs"
    :data-component="section.__component"
    :title="refTitle"
    :title-tag="section.layout?.titleTag"
    :description="refDescription"
    :color="refBackgroundColor"
    :space="section.layout?.space"
  >
    <div class="section-discipline-needs__body">
      <div
        class="section-discipline-needs__illustration"
        aria-hidden="true"
      >
        <span class="section-discipline-needs__photo-mask">
          <picture>
            <source
              type="image/webp"
              :srcset="photoWebp"
            >
            <img
              class="section-discipline-needs__photo"
              :src="photo"
              alt=""
              width="1024"
              height="683"
              loading="lazy"
              decoding="async"
            >
          </picture>
        </span>
        <img
          class="section-discipline-needs__decoration section-discipline-needs__decoration--mobile"
          :src="decorationMobile"
          alt=""
          width="345"
          height="204"
          loading="lazy"
        >
        <img
          class="section-discipline-needs__decoration section-discipline-needs__decoration--tablet"
          :src="decorationDesktop"
          alt=""
          width="660"
          height="390"
          loading="lazy"
        >
      </div>
      <ul class="section-discipline-needs__links">
        <li
          v-for="(link, index) in section.links"
          :key="link.id ?? index"
          class="section-discipline-needs__links-item"
        >
          <BlockLinkCard :block="link" />
        </li>
      </ul>
    </div>
  </SectionLayout>
</template>

<style scoped lang="scss" src="@scss/components/Sections/SectionDisciplineNeeds.scss" />
